import { createResource } from '../utils/resource'

const companyAssetStore = createResource('companyAsset', {})

export default companyAssetStore
